import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { garAxios } from "./garApi";
import useVaipedeManifest from "./useVaipedeManifest";
import { Loader2, UtensilsCrossed } from "lucide-react";

export default function VaiPedeGarcomLoginPage() {
  useVaipedeManifest();
  const navigate = useNavigate();
  const [f, setF] = useState({ whatsapp: "", senha: "" });
  const [loading, setLoading] = useState(false);
  const upd = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await garAxios.post("/vaipede/garcom/login", f);
      localStorage.setItem("vaipede_garcom_token", data.token);
      localStorage.setItem("vaipede_garcom", JSON.stringify(data.garcom));
      toast.success(`Bem-vindo(a), ${data.garcom.nome}!`);
      navigate("/vaipede/garcom");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erro no login");
    } finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-900 to-red-950 grid place-items-center p-4" data-testid="vaipede-garcom-login">
      <div className="w-full max-w-sm">
        <div className="text-center mb-6">
          <div className="w-16 h-16 rounded-2xl bg-[#EA1D2C] grid place-items-center mx-auto mb-4">
            <UtensilsCrossed className="w-8 h-8 text-white"/>
          </div>
          <h1 className="text-3xl font-black text-white">Garçom · VAI <span className="text-[#EA1D2C]">PEDE</span></h1>
          <p className="text-sm text-neutral-400 mt-1">Login do atendimento</p>
        </div>
        <form onSubmit={submit} className="space-y-3 bg-white rounded-2xl p-5">
          <input required value={f.whatsapp} onChange={upd("whatsapp")} placeholder="WhatsApp (só números)" className="w-full px-4 py-3 rounded-xl border border-neutral-200 outline-none focus:border-[#EA1D2C]" data-testid="vaipede-garcom-input-whatsapp"/>
          <input required type="password" value={f.senha} onChange={upd("senha")} placeholder="Senha" className="w-full px-4 py-3 rounded-xl border border-neutral-200 outline-none focus:border-[#EA1D2C]" data-testid="vaipede-garcom-input-senha"/>
          <button type="submit" disabled={loading} className="w-full py-3 rounded-xl bg-[#EA1D2C] text-white font-black hover:bg-[#c8121f] disabled:opacity-60 flex items-center justify-center gap-2" data-testid="vaipede-garcom-btn-login">
            {loading && <Loader2 className="w-4 h-4 animate-spin"/>} Entrar
          </button>
          <p className="text-xs text-neutral-500 text-center pt-2">
            Não tem acesso? Peça ao dono do restaurante em Configurações → Garçons.
          </p>
        </form>
      </div>
    </div>
  );
}
